import {
  ExpandableSection,
  SpaceBetween,
  ColumnLayout,
  TextContent,
  Box,
} from "@cloudscape-design/components-themed";
import { useState } from "react";
import { MerchantInfoForBankAccount } from "../../../features/api-interfaces";
import { formatLabel, joinStrings } from "../../../utils/format";
import { COMMON_LABELS } from "../../default-constants";
import InfoField from "../../UI/InfoField";
import { LABELS } from "../constants";

interface IMerchantInfoExpandableSection {
  headerText: string;
  merchantInfoList?: MerchantInfoForBankAccount[];
}

/**
 * 入金口座情報照会・更新 加盟店情報 展開表示
 */
export const MerchantInfoExpandableSection = (
  props: IMerchantInfoExpandableSection
) => {
  const { headerText, merchantInfoList } = props;
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <ExpandableSection
      variant={"container"}
      headerText={formatLabel(headerText, [merchantInfoList?.length ?? 0])}
      expanded={isExpanded}
      onChange={() => setIsExpanded(!isExpanded)}
    >
      {merchantInfoList?.map((merchantInfo) => (
        <Box key={merchantInfo.ipid}>
          <SpaceBetween direction={"horizontal"} size={"xxl"}>
            <ColumnLayout columns={2}>
              <InfoField
                direction={"vertical"}
                size={"xxs"}
                tag={"h4"}
                values={[LABELS.IPID]}
              />
            </ColumnLayout>
            <InfoField
              direction={"vertical"}
              size={"xxxs"}
              tag={"p"}
              values={[merchantInfo.ipid]}
            />
          </SpaceBetween>
          <TextContent>
            <p>
              {joinStrings(
                merchantInfo.tradeNameList,
                COMMON_LABELS.ZENKAKU_TOUTEN
              )}
            </p>
          </TextContent>
          {COMMON_LABELS.FULL_WIDTH_SPACE}
        </Box>
      ))}
    </ExpandableSection>
  );
};
